import Settings from '../../../../../../settings/Settings';

const ID = {
    USER: 'User',
    SQUADS: 'Squads',
};

const LABEL = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 56,
    TINT: 0x000000,
};

export default class Button extends Phaser.GameObjects.Container {
    public id: 'User' | 'Squads';
    private selected: boolean = false;
    private bg!: Phaser.GameObjects.Image;
    private label!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number, id: 'User' | 'Squads') {
        super(scene, x, y);

        this.id = id;

        this.setupBG();
        this.setupLabel();
    }

    static get ID() {
        return ID;
    }

    setupBG() {
        let frame = 'gui/leaderboard/selector_button_off';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.add(this.bg);

        this.bg.setInteractive({ useHandCursor: true });
        this.bg.on('pointerdown', () => this.emit('click', this));
    }

    setupLabel() {
        let x = 0;
        let y = -7;

        this.label = this.scene.add.bitmapText(x, y, LABEL.FONT, this.id, LABEL.SIZE);
        this.label.setOrigin(0.5);
        this.label.setTint(LABEL.TINT);
        this.add(this.label);
    }

    select() {
        let frame = 'gui/leaderboard/selector_button_on';

        this.selected = true;
        this.bg.setFrame(frame);
        this.bg.disableInteractive();
    }

    deselect() {
        let frame = 'gui/leaderboard/selector_button_off';

        this.selected = false;
        this.bg.setFrame(frame);
        this.bg.setInteractive();
    }
}
